import { render, staticRenderFns } from "./caixa.vue?vue&type=template&id=0d0b7484&scoped=true&"
import script from "./caixa.vue?vue&type=script&lang=js&"
export * from "./caixa.vue?vue&type=script&lang=js&"
import style0 from "./caixa.vue?vue&type=style&index=0&id=0d0b7484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0b7484",
  null
  
)

export default component.exports